import React from 'react';
import { Check, X } from 'lucide-react';
import CircularProgressBar from '../../circular-progress';

const InlineEditSaveCancel = ({ onSave, onCancel, saving, saveAriaLabel = 'Save' }) => (
  <>
    <button
      type="button"
      className="btn btn-link p-0 mr-1 text-success d-inline-flex align-items-center justify-content-center shadow-none"
      style={{ minWidth: 20, minHeight: 20 }}
      aria-label={saveAriaLabel}
      disabled={saving}
      onClick={() => void onSave?.()}
    >
      {saving ? <CircularProgressBar size={1.3} className="text-muted" /> : <Check size={18} className="flex-shrink-0" />}
    </button>
    <button
      type="button"
      className="btn btn-link p-0 text-danger d-inline-flex align-items-center shadow-none"
      aria-label="Cancel"
      disabled={saving}
      onClick={onCancel}
    >
      <X size={18} className="flex-shrink-0" />
    </button>
  </>
);

export default InlineEditSaveCancel;
